import { gql } from '@apollo/client';

export const GET_PARKING_ZONE_LANES = gql`
  query readParkingZoneLanes($parkingZoneUid: String!) {
    readParkingZoneLanes(input: { parkingZoneUid: $parkingZoneUid }) {
      confidence
      laneGroupId
      laneId
      systemId
    }
  }
`;
